export default "__VITE_ASSET__qt9J_zwl__"